<template lang="pug">
app-main-content-layout(title='Stripe Connect')
  div
    .card-header.p-4.bg-transparent
      .row.row-sm.align-items-center
        .col
          h6.mb-0(v-for="(message, index) in responseMessage" :key="index") {{message}}
</template>

<script>

import {
  defineComponent,
  onMounted,
} from 'vue';
import shared from '../shared';

export default defineComponent({
  name: 'ConfirmOrgOnboard',
  components: {},
  setup() {
    const {
      ref,
      route,
      router,
      doCompleteStripeOnboarding,
    } = shared();
    const { code, state } = route.query;
    const loading = ref(true);
    const organization = ref({});
    const responseMessage = ref([]);

    const TRY_AGAIN = 'To try again, open your organization\'s Stickers page and choose "Connect Stripe".';

    async function completeStripeOnboarding() {
      // Opened without Stripe's answer (e.g. a bookmarked or reloaded link): nothing to confirm
      if (!code) {
        responseMessage.value = [
          'This page needs the confirmation from Stripe, which is missing.',
          TRY_AGAIN,
        ];
        return;
      }
      responseMessage.value.push('Connecting your organization to its Stripe account…');
      try {
        const response = await doCompleteStripeOnboarding(
          code,
          state,
        );
        organization.value = response;
        console.log('organization.value', organization.value);
        if (organization.value.stripe_onboarded) {
          responseMessage.value.push(`Stripe account successfully connected for ${organization.value.name}.`);
          responseMessage.value.push(`Redirecting to ${organization.value.name} organization...`);
          router.push(`/manage/orgs/${organization.value.id}/edit`);
        } else {
          responseMessage.value.push(`Could not connect the Stripe account for ${organization.value.name}.`);
          responseMessage.value.push(TRY_AGAIN);
        }
      } catch (err) {
        responseMessage.value.push('Something went wrong while confirming the Stripe account.');
        responseMessage.value.push(TRY_AGAIN);
      }
    }

    onMounted(async () => {
      loading.value = true;
      responseMessage.value.push('Waiting for Stripe…');
      await completeStripeOnboarding();
      loading.value = false;
    });

    return {
      loading,
      organization,
      responseMessage,
    };
  },
});
</script>
